import '.f{width:100%;}.ssr-plugin'
import '.d6{height:4px;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ap{gap:12px;}.ssr-plugin'
import '.d7{align-items:flex-start;}.ssr-plugin'
import '.bh{align-self:stretch;}.ssr-plugin'
import '.d8{border-radius:999px;}.ssr-plugin'
import '.d9{opacity:0.15;}.ssr-plugin'
import '.am{overflow:hidden;}.ssr-plugin'
import '.da{transition:width 120ms ease-out;}.ssr-plugin'
import '.u{position:absolute;}.ssr-plugin'
import '.db{left:0px;}.ssr-plugin'
import '.dc{top:0px;}.ssr-plugin'
import '.cy{padding:24px;}.ssr-plugin'
import '.ak{position:fixed;}.ssr-plugin'
import '.a4{bottom:0px;}.ssr-plugin'
import '.dd{right:0px;}.ssr-plugin'
import '.p{margin:0 auto;}.ssr-plugin'
import '.cx{max-width:1280px;}.ssr-plugin'
import '.bj{justify-content:space-between;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.de{gap:48px;}.ssr-plugin'
import '.af{align-items:start;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import { FC } from 'react'
import { Text } from './Text'
import { Button } from './Button'
import { useTheme } from '../providers/useTheme'
import { Link } from 'wouter'
import { styled } from 'inlines'
import { useAppCtx } from '../providers/useAppCtx'
import { formatCurrency } from '@/apps/cms/utils/misc'
import { useTranslations } from '../hooks/useTranslations'

type CartItemsIndicatorProps = {
  cartItems?: number
  cartItemsMax?: number
  cartItemsMin?: number
  color?: string
}

export const CartItemsIndicator: FC<CartItemsIndicatorProps> = ({
  cartItems = 0,
  cartItemsMax = 0,
  cartItemsMin = 0,
  color = '#FFFFFF',
}) => {
  const ratio =
    cartItemsMax && cartItemsMax > 0 ? Math.min(cartItems / cartItemsMax, 1) : 0

  const widthMinVotesBar = Math.floor((cartItemsMin / cartItemsMax) * 100)
  const diff = cartItemsMax - cartItemsMin

  const ratioForSecondBar =
    cartItems >= cartItemsMin ? ((cartItems - cartItemsMin) / diff) * 100 : 0

  return cartItemsMin && cartItemsMin > 1 ? (
    <div className="f d6 s a ap"
    >
      {/* minvotes bar */}
      <div className="d6 s"
        style={{
          width: widthMinVotesBar + '%',}}
      >
        <div className="a d6 d7 bh d8 d9 am"
          style={{
            background: color,}}
        ></div>
        <div className="d6 d8 da u db dc"
          style={{
            width:
              cartItems < cartItemsMin
                ? `${(cartItems / cartItemsMin) * 100}%`
                : '100%',
            background: color,}}
        />
      </div>

      {/* second bar */}
      <div className="d6 s"
        style={{
          width: `calc(100% - ${widthMinVotesBar}%`,}}
      >
        <div className="a d6 d7 bh d8 d9 am"
          style={{
            background: color,}}
        ></div>
        <div className="d6 d8 da u db dc"
          style={{
            width: `${ratioForSecondBar}%`,
            background: color,}}
        />
      </div>
    </div>
  ) : (
    <div className="f d6 s"
    >
      <div className="a d6 d7 bh d8 d9 am"
        style={{
          background: color,}}
      ></div>
      <div className="d6 d8 da u db dc"
        style={{
          width: `${ratio * 100}%`,
          background: color,}}
      />
    </div>
  )
}

export const CartBar: FC = () => {
  const { colors } = useTheme()

  const {
    votesCount,
    activeLanguage,
    price,
    currency,
    maxVotes,
    minVotes = 0,
  } = useAppCtx()
  const { data: cartTranslations } = useTranslations('cart')

  const priceLabel = formatCurrency(
    (votesCount * price) / 100,
    currency,
    activeLanguage,
  )

  return (
    <div className="f cy ak a4 dd db"
      style={{
        background: colors.primaryAccent,}}
    >
      <div className="p f cx a bj d de"
      >
        <div className="f af a i ap"
        >
          <CartItemsIndicator
            cartItems={votesCount}
            cartItemsMax={maxVotes}
            cartItemsMin={minVotes}
            color={colors.background}
          />

          <Text variant="display-regular" color={colors.background}>
            {minVotes && votesCount < minVotes
              ? cartTranslations?.minVotes_indicator
              : `${cartTranslations?.counting_votes_indicator} - ${priceLabel}`}
          </Text>
        </div>

        <Link href="/cart">
          <Button
            isDisabled={minVotes ? votesCount < minVotes : false}
            id="cartbar-link-cart"
            label={cartTranslations?.add_to_cart_button}
            trailIcon="arrow"
            style={{ background: colors.background }}
            color={colors.primaryAccent}
          />
        </Link>
      </div>
    </div>
  )
}
